require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-180-setup-procore-integration-with-teamgantt.json") })
        }
      }, "path---article-180-setup-procore-integration-with-teamgantt");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-180-setup-procore-integration-with-teamgantt!./.cache/json/article-180-setup-procore-integration-with-teamgantt.json
// module id = 529
// module chunks = 231608221292675